/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Address/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Address({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Email/Emails/Content/Email/Edit/Content/Fields/Address",
  isInvalid,
  onChange
  
}) {
let editEmailEmailAddressValueData = fromData.useDataValue({ viewPath,
context: 'edit_email',
path: 'email.address',
})
let editEmailEmailAddressIsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit_email',
path: 'email.address',
validate: fromValidate.email,
required: true,
})
let editEmailEmailAddressChangeData = fromData.useDataChange({ viewPath,
context: 'edit_email',
path: 'email.address',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="edit_email.email.address"
 validate="/Data/validate.js email"
 invalid={!editEmailEmailAddressIsValidData}
 required={true}
 value={editEmailEmailAddressValueData}
 onChange={editEmailEmailAddressChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Email Address"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="email"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}